"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _nhanh = require("@/api/nhanh");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ForControlModal = _interopRequireDefault(require("../tour/components/ForControlModal.vue"));
var ForControl = /*#__PURE__*/function (_Vue) {
  function ForControl() {
    var _this;
    (0, _classCallCheck2.default)(this, ForControl);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ForControl, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", {
      dataTable: []
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "code", "");
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "loadingInput", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(ForControl, _Vue);
  return (0, _createClass2.default)(ForControl, [{
    key: "handleDeleteAll",
    value: function handleDeleteAll() {
      this.form.dataTable = [];
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(row) {
      this.form.dataTable = this.form.dataTable.filter(function (e) {
        return e.id != row.id;
      });
    }
  }, {
    key: "handleControl",
    value: function handleControl() {
      this.$refs.forControlModal.handleView((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
        orders: this.form.dataTable
      }));
    }
  }, {
    key: "updateData",
    value: function updateData(data) {
      this.form.dataTable = data;
    }
  }, {
    key: "handleSearchOrder",
    value: function () {
      var _handleSearchOrder = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(id) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(id == "")) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.loadingInput = true;
              if (!this.form.dataTable.some(function (e) {
                return e.orderId == id;
              })) {
                _context.next = 7;
                break;
              }
              this.code = "";
              this.loadingInput = false;
              return _context.abrupt("return", this.$notify.error({
                title: "Đơn hàng đã tồn tại",
                message: "Error"
              }));
            case 7:
              _context.prev = 7;
              _context.next = 10;
              return _nhanh.nhanhApi.findAll({
                id: id
              });
            case 10:
              res = _context.sent;
              this.form.dataTable.push(res.data[0]);
              this.code = "";
              this.loadingInput = false;
            case 14:
              _context.prev = 14;
              this.loadingInput = false;
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7,, 14, 17]]);
      }));
      function handleSearchOrder(_x) {
        return _handleSearchOrder.apply(this, arguments);
      }
      return handleSearchOrder;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ForControl = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ForControlModal: _ForControlModal.default
  }
})], ForControl);
var _default = exports.default = ForControl;